var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill":"#2E53A3"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"5","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }